<template>
    <v-card color="grey darken-3" class="mb-2" max-width="600">
        <v-card-text class="pa-2">

            <div class="d-flex justify-space-between">
                <div class="d-flex">

                    <v-switch
                        class="ml-2 align-self-center"
                        v-model="model"
                        label=""
                        color="primary"
                    ></v-switch>

                    <div class="align-self-center body-1 ml-3">
                        {{ text }}
                        <div class="caption">
                            {{ description }}
                        </div>
                    </div>

                </div>

                <v-icon size="30" :color="model ? 'primary' : 'grey'" class="align-self-center justify-end mr-5">
                    {{ icon }}
                </v-icon>
            </div>

        </v-card-text>
    </v-card>
</template>

<script>

export default {

    props: {
        value: {
            required: true,
            type: Boolean,
        },
        text: {
            required: true,
            type: String,
            default: "Text prop not provided"
        },
        description: {
            required: true,
            type: String,
            default: "Description prop not provided"
        },
        icon: {
            required: false,
            type: String,
            default: null
        }
    },

    computed: {
        model: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
}
</script>
